import { storyblokEditable, StoryblokServerComponent } from "@storyblok/react/rsc";
import { IconBlockStoryblok, ButtonStoryblok } from "@/component-types-sb";
import Title from "@/components/Title";
import LucideIcon from "@/components/LucideIcon";
import Link from "next/link";
import { cn } from "@/lib/utils";

interface IconBlockProps {
  blok: IconBlockStoryblok;
  className?: string
}

const IconBlock: React.FunctionComponent<IconBlockProps> = ({ blok, className }) => {
  const content = (
    <>
      {blok.icon && (
        <LucideIcon name={blok.icon} className="h-6 w-6 text-primary min-w-6" />
      )}
      <div className="flex-1">
        <Title variant="h3" subvariant="secondary">{blok.title}</Title>
        <p>{blok.description || ""}</p>
      </div>
    </>
  );

  return (
    <div
      {...storyblokEditable(blok)}
      className={cn(
        className,
        "flex flex-row flex-wrap items-center gap-8 bg-card-muted rounded-lg p-6"
      )}
    >
      {blok.link ? (
        <Link 
          href={blok.link || '#'}
          className="flex flex-row items-center gap-6 w-full h-full"
        >
          {content}
        </Link>
      ) : (
        content
      )}
      {!blok.link &&
          blok.buttons?.map((button: ButtonStoryblok) => (
            <StoryblokServerComponent blok={button} key={button._uid} />
          ))}
    </div>
  );
};

export default IconBlock;